import axios from 'axios';
import { getToken } from '../utils/utils';
import store from '../store/store';

export async function getApiRequestHeader(isFormData = false, isOtp = false) {
  try {
    const token = getToken();
    const timestamp = new Date().getTime();
    const { otp_token } = store.getState().auth;

    let header_obj = {
      Accept: 'application/json',
      'Content-Type': isFormData ? 'multipart/form-data' : 'application/json',
      Authorization: token?.length > 0 ? `Bearer ${token}` : null,
      SessionId: timestamp,
    };

    if (isOtp) header_obj['X-OTP-Verification'] = otp_token;

    return header_obj;
  } catch (error) { }
}

const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 600000,
  withCredentials: false,
});

export async function updateHeaders(isFormData = false, isOtp = false) {
  const header = await getApiRequestHeader(isFormData, isOtp);
  instance.defaults.headers = header;
}

export async function request({ method, url, data, headers, isFormData = false, isOtp = false }) {
  if (headers === undefined) {
    await updateHeaders(isFormData, isOtp);
  }
  const promise = instance[method](url, data);
  let response;
  try {
    response = await promise;
  } catch (error) {
    throw error.response;
  }
  return response?.data;
}

export async function newRequest({ method, url, data, isFormData = false, headers }) {
  if (headers === undefined) {
    await updateHeaders(isFormData);
  }
  const promise = instance[method](url, data);
  let response;
  try {
    response = await promise;
  } catch (error) {
    throw error.response;
  }
  if (response.status ? response.status.toString().indexOf('2') !== 0 : response.data.status.toString().indexOf('2') !== 0) {
    // eslint-disable-next-line
    throw { response };
  } else {
    return response.data;
  }
}

export async function get(url, params) {
  const query = new URLSearchParams(params).toString();
  if (query) {
    url += (url.includes('?') ? '&' : '?') + query;
  }
  return request({ method: 'get', url });
}

export async function del(url, params) {
  return request({ method: 'delete', url, data: { params } });
}

export async function post(url, data, isFormData = false, isOtp = false) {
  return request({ method: 'post', url, data, isFormData, isOtp });
}

export async function put(url, data, isFormData = false) {
  return request({ method: 'put', url, data, isFormData });
}
export async function patch(url, data, isFormData = false) {
  return request({ method: 'patch', url, data, isFormData });
}
export const independentRequest = async (url, method, data) => {
  const promise = axios[method](url, data);
  let response;
  try {
    response = await promise;
  } catch (error) {
    throw error.response;
  }
  const payload = response;
  return payload;
};
